import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { LayoutProps } from './types';
import Toaster from '../common/Toaster';

const BaseLayout = ({ title, children }: LayoutProps) => {
  useEffect(() => {
    document.title = `${title ? title + ' | Flightdeck' : 'Flightdeck'}`;
  }, [title]);

  useEffect(() => {
    // Set html class for windows specific css, allows css override of ugly windows scrollbars .. etc
    if (navigator.userAgent.indexOf('Win') !== -1) {
      document.querySelector('html')?.classList.add('os-windows');
    }
    // Add body classes
    document.querySelector('body')?.classList.add('windows-scrollbar');
  }, []);

  return (
    <>
      {children}
      <Toaster />
      <ToastContainer
        icon={false}
        position="bottom-right"
        autoClose={4000}
        hideProgressBar
      />
    </>
  );
};

export default BaseLayout;
